import React from 'react';
import ReactDom from 'react-dom';
import Select from 'react-select';
import Console from '../../../lib/debug';

export default class DropSimple extends React.Component {
    openDrop() {
        setTimeout(() => {
            document.body.classList.toggle('fixWindow', true);
            this.props.onOpen && this.props.onOpen();
        }, 10);
    }

    closeDrop() {
        document.body.classList.remove('fixWindow');
        this.props.disableButtons && this.props.disableButtons();
    }

    handleChange(...args) {
        this.props.onChange(...args);
        this.forceUpdateSelectorHeight();
    }

    focus() {
        if (this.node.select) {
            this.node.select.focus();
        } else {
            this.node.focus();
        }
    }

    /**
     * Force update selector height
     *
     * This fixes issues experienced in Chrome/Mac where the
     * React-Virtualized-Select's internal AutoSize Component does not update
     * until the element received a focus/blur event.
     * https://github.com/bvaughn/react-virtualized-select/issues/2
     * @return {any} null
     */
    forceUpdateSelectorHeight() {
        // eslint-disable-next-line react/no-find-dom-node
        const element = ReactDom.findDOMNode(this.node);
        if (element) {
            // eslint-disable-next-line no-undef
            element.style.height = window.getComputedStyle(element).height;
            setTimeout(() => {
                element.style.height = 'auto';
            }, 0);
        }
    }
    render() {
        Console.render('designer.DropSimple');
        let value = this.props.value;
        let valueKey = this.props.valueKey;
        let labelKey = this.props.labelKey;
        let options = this.props.options;
        let filterOptions = this.props.filterOptions;

        let clearable = this.props.clearable;
        let multi = this.props.multi;
        let joinValues = this.props.joinValues;
        let searchable = this.props.searchable;
        let placeholder = this.props.placeholder;
        let className = this.props.className;
        let openOnFocus = this.props.openOnFocus;
        let autofocus = this.props.autofocus;
        let autoBlur = this.props.autoBlur;
        let arrowRenderer = this.props.arrowRenderer;
        let optionRenderer = this.props.optionRenderer;
        let promptTextCreator = this.props.promptTextCreator;
        let style = this.props.style;

        return (
            <Select
                value={value}
                valueKey={valueKey}
                labelKey={labelKey}
                options={options}
                arrowRenderer={arrowRenderer}
                optionRenderer={optionRenderer}
                filterOptions={filterOptions}
                promptTextCreator={promptTextCreator}
                clearable={clearable}
                searchable={searchable}
                placeholder={placeholder}
                multi={multi}
                joinValues={joinValues}
                className={className}
                openOnFocus={openOnFocus}
                autoFocus={autofocus}
                autoBlur={autoBlur}
                onOpen={this.openDrop.bind(this)}
                onClose={this.closeDrop.bind(this)}
                ref={node => {
                    this.node = node;
                }}
                onChange={this.handleChange.bind(this)}
                style={style}
            />
        );
    }
}
